import { useContext, useMemo } from "react";
import { GlobalContext } from "./context";

const useAlert = (Context) => {
  const alertContext = useContext(Context || GlobalContext);

  const alert = useMemo(() => {
    return alertContext;
  }, [alertContext]);
  return {
    showConfirmDialog: alert.showConfirmDialog,
    showAlert: alert.showAlert,
    showLoading: alert.showLoading,
    dismissLoading: alert.dismissLoading,
    showInputDialog: alert.showInputDialog,
  };
};

export default useAlert;
